import { Button, styled } from "@mui/material";
import theme from "../../styles/theme";

const StyledLoginButton = styled(Button)({
  borderRadius: theme.spacing(3),
  fontSize: 16,
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
});
export default StyledLoginButton;
